var _circle, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTargetValueIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 30,
    cy: 30,
    r: 30,
    fill: "black",
    fillOpacity: 0.22
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.2767 13V17.3631C22.8692 17.7234 17.7287 22.8707 17.3631 29.2767H13V30.7233H17.3631C17.7234 37.1344 22.8658 42.2759 29.2767 42.6369V47H30.7233V42.6369C37.1344 42.2759 42.2765 37.1344 42.6369 30.7233H47V29.2767H42.6369C42.2713 22.8704 37.1309 17.7235 30.7233 17.3631V13H29.2767ZM29.2767 18.8098V23.1277H30.7233V18.8098C36.3459 19.1665 40.8316 23.6545 41.1901 29.2765H36.8721V30.7232H41.1901C40.8333 36.3465 36.3469 40.8334 30.7233 41.19V36.872H29.2767V41.19C23.6534 40.8332 19.1664 36.3468 18.8099 30.7232H23.1279V29.2765H18.8099C19.1682 23.6545 23.6541 19.1663 29.2767 18.8098ZM30 26.7446C28.2021 26.7446 26.7448 28.2021 26.7448 29.9998C26.7448 31.7977 28.2023 33.255 30 33.255C31.7979 33.255 33.2552 31.7975 33.2552 29.9998C33.2552 28.2019 31.7977 26.7446 30 26.7446Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTargetValueIcon);
export default __webpack_public_path__ + "static/media/target-value-icon.0c2b1ca44f297f0a7b6b8f711e412644.svg";
export { ForwardRef as ReactComponent };